import React from "react";
import './BestBank.css';

class BestBank extends React.Component {
    render() {
        return (
            <article className="article br3 ba b--black-10 w-100 w-50-m w-50-l mw7 shadow-5 center">
                <main className="pa4 black-80">
                    <div className="measure">
                        <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
                            <div className='legend center'>
                                <legend className="f1 fw6 ph0 mh0">
                                    احسن بنك تفتح فيه
                                <br/>
                                    بدون اقامه
                                </legend>
                            </div>
                            <hr/>

                            <div className="ui form ma0">
                                <div className="fields">
                                    <h3>
                                        هشرح بشكل مفصل شويه عشان 
                                        <br/>
                                        مشرحش تفصيلا بس ركزوا معايا <a target='_blank' rel='noreferrer' href='https://www.facebook.com/alimansours'>Ali Mansour</a>
                                        <br/>
                                        بالنسبه للبنك الجديد اللي اسمه vivid ليه بنقول
                                        <br/>
                                        لطيف جدا
                                        <br/>
                                        فتحت فيه من فتره كنت بجربه وبصراحه لو عرفته من الاول كنت وفرت كتير
                                        <br/>
                                        البنك بيدي cashback علي اماكن كتير من aldi, dm , rewe , edka, Lieferando, saturn, decathlon, Kaufland
                                        <br/>
                                        والليسته دي بتتغير كل فتره بينزل اماكن جديده واماكن العرض فيها بيخلص بتضغط ع المكان تعرف العرض شغال لحد امتي  
                                        <br/>
                                        هسيب لكم فيديو بالحاجات اللي موجوده عليها كاش باك حاليا لانهم كتير  
                                        <br/>
                                        فكرته بكل بساطه واللي محببني فيه انا كدا كدا هروح اشتري مثلا من السوبر ماركت وليكن Edka البنك مثلا عنده عرض ١٥٪ cashback يرجعلك لو اشتريت من ايديكا .. يبقي انا كدا وفرت النسبه دي من حاجه انا كدا كدا كنت هشتريها فاهم قصدي ؟
                                        <br/>
                                        من راي يتعامل معامله كارت المشتريات هيبقي مفيد جدا 
                                        <br/>
                                        اهو الواحد يستفاد من اي cashback يرجعله
                                        <br/>
                                        في حاجات بتوصل ٢٥٪ بيرجعولك و لما بتفتح الحساب بيديك prime لمده قصيره ٣ شهور ..الكاش فيها اعلي من الحساب ال Standard
                                        <br/>
                                        - ملوش رسوم أداريه الا لو هتعمل prime وشايف ان مش وقته لو انت لسه واصل المانيا 
                                        <br/>
                                        - فيه ميزه كمان لو عملت حاجه اسمها sub account  او. Space بيدهالك ب Iban تاني .. دا مفيده للناس اللي حابه تفصل تعامل شغل مثلا عن حسابها الرئيسي
                                        <br/>
                                        - في حته كدا مهمه￼ف prime 
                                        ان بيخلي الكاش باك ممكن تسيبها علي شكل مضابرات  اسهم وبتختارها زي tesla وبيضاربلك فيها كسبت ٥ يورو مثلا من الهوا
                                        <br/>￼
                                        - الامان فيه عالي لان الكارت بيجي معلهوش اصلا بيانات IBAN ولا تاريخه ولا CVV
                                        <br/>
                                        اللي عجبني في برده في كل دا الكارت بتاعهم metal وانا اول مره اطلع كارت بنك ميتل
                                        <br/>
                                        - نصيحتي ليك: خليه جنب n26  لو هتسحب فلوس اسحب من n26 ولو هتشتري ولو حتي اونلاين او اكلك الاسبوعي اشتري ب Vivid وركز في المكان اللي معاه cashback يعني لو جنبك rewe و aldi  اختار اللي معاه العرض انت اولي
                                        <br/>
                                        دا <a target='_blank' rel='noreferrer' href='https://vivid.money/r/ahmed7PU'>لينك</a> الدعوه
                                        <br/>
                                        الدعوه دي هتديك ٥ يورو وانا ٥٠ يورو
                                        <br/>
                                        طريقته سهله مجرد ما تخش علي اللينك وتسجل بيناتك كدا هتنزل بعدها App و تعمل تاكيد للهويه وكدا اتفتح
                                        <br/>
                                        تعديل بسيط :  بفتح دلوقتي لقيت الابلكيشن قلل الفلوس اللي هتجيلك من الدعوه ل ٥ يورو كانت لمبارح ب ٢٥ يورو والله
                                        <br/>
                                        واسم البنك <a target='_blank' rel='noreferrer' href='https://vivid.money/en-eu/'>vivid</a>
                                    </h3>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </main>
            </article>
        );
    }
}

export default BestBank;
